import { getCommandsAnswers } from 'nove8/helpers/getCommandsAnswers'
import { getQuestionValues } from 'nove8/helpers/getQuestionValues'
import { isEmpty } from 'lodash'
import { TAnswers } from 'models/common.model'
import { useEffect } from 'react'
import {
  AnswerKey,
  EventLoggerInstanceName,
  GENERAL_QUESTIONS_OPTIONS_VALUES,
  IDK,
  NONE,
} from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { getDogProblemFromSavedAnswers } from 'nove8/helpers/getDogProblemFromSavedAnswers'
import { useGetSavedAnswers } from './useGetSavedAnswers'

const getSingleValue = (
  fields: string[],
  answers: Partial<TAnswers> | null,
  isFullAnswers = false,
): string | string[] =>
  isEmpty(answers)
    ? ''
    : (Object.values(
        getQuestionValues(answers, fields, isFullAnswers) || {},
      )[0] as string | string[])

const getAnswerField = <T>(key: string, value: T | undefined) =>
  value ? { [key]: value } : {}

export const useSendSavedAnswers = (): void => {
  const answers = useGetSavedAnswers()

  useEffect(() => {
    const shouldUpdateUserProperties = answers && !isEmpty(answers)

    if (!shouldUpdateUserProperties) return

    const dogAge = getSingleValue([AnswerKey.AGE, AnswerKey.WS2_AGE], answers)

    const dogBreed = getSingleValue(
      [AnswerKey.DOG_BREED, AnswerKey.WELLNESS_BREED, AnswerKey.WS2_BREED],
      answers,
    )

    const dogGender = getSingleValue(
      [AnswerKey.SEX, AnswerKey.WELLNESS_SEX, AnswerKey.WS2_SEX],
      answers,
    )

    const shelterAnswer = getSingleValue(
      [AnswerKey.SHELTER, AnswerKey.WELLNESS_SHELTER],
      answers,
    )

    const dogProblem = getDogProblemFromSavedAnswers(answers)

    const commandsAnswers = getCommandsAnswers(answers)
    const commandsAnswersLength =
      commandsAnswers.includes(IDK) || commandsAnswers.includes(NONE)
        ? 0
        : commandsAnswers.length

    const options = {
      ...getAnswerField('dog_age', dogAge),
      ...getAnswerField('dog_breed', dogBreed),
      ...getAnswerField('dog_gender', dogGender),
      ...(shelterAnswer
        ? { is_shelter: shelterAnswer === GENERAL_QUESTIONS_OPTIONS_VALUES.YES }
        : {}),
      ...(dogProblem ? { dog_problem: dogProblem } : {}),
      ...(commandsAnswersLength > 0
        ? { commands_picked: commandsAnswersLength }
        : {}),
    }

    eventLogger.updateUserPropertiesByLogger({
      loggersNames: [
        EventLoggerInstanceName.AMPLITUDE,
        EventLoggerInstanceName.RUDDERSTACK,
      ],
      options,
    })
    // disabled because we want to send the saved answers only once with the first mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
